module.exports = __webpack_public_path__ + "static/media/ic-twitter.459250e8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic-twitter.svg
// module id = 326
// module chunks = 0